<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" class="icon">
    <g>
      <path
        style="text-indent:0;text-align:start;line-height:normal;text-transform:none;block-progression:tb;-inkscape-font-specification:Sans"
        d="M 25 1 C 11.756603 1 1 11.756603 1 25 C 1 38.243397 11.756603 49 25 49 C 32.742396 49 39.623552 45.293771 44 39.59375 A 1.0001 1.0001 0 1 0 42.40625 38.40625 C 38.390698 43.636229 32.107604 47 25 47 C 12.837397 47 3 37.162603 3 25 C 3 12.837397 12.837397 3 25 3 C 32.107604 3 38.390698 6.3637708 42.40625 11.59375 A 1.0001 1.0001 0 1 0 44 10.40625 C 39.623552 4.7062292 32.742396 1 25 1 z M 39.90625 15.96875 A 1.0001 1.0001 0 0 0 39.78125 16 A 1.0001 1.0001 0 0 0 39.28125 17.71875 L 45.5625 24 L 24 24 A 1.0001 1.0001 0 0 0 23.90625 24 A 1.001098 1.001098 0 0 0 24 26 L 45.5625 26 L 39.28125 32.28125 A 1.016466 1.016466 0 1 0 40.71875 33.71875 L 48.5625 25.84375 A 1.0001 1.0001 0 0 0 48.78125 25.65625 A 1.0001 1.0001 0 0 0 48.78125 25.625 A 1.0001 1.0001 0 0 0 48.9375 25.40625 A 1.0001 1.0001 0 0 0 48.9375 25.375 A 1.0001 1.0001 0 0 0 48.96875 25.3125 A 1.0001 1.0001 0 0 0 48.96875 25.28125 A 1.0001 1.0001 0 0 0 49 25.1875 A 1.0001 1.0001 0 0 0 49 24.875 A 1.0001 1.0001 0 0 0 49 24.8125 A 1.0001 1.0001 0 0 0 49 24.78125 A 1.0001 1.0001 0 0 0 48.96875 24.71875 A 1.0001 1.0001 0 0 0 48.96875 24.6875 A 1.0001 1.0001 0 0 0 48.9375 24.625 A 1.0001 1.0001 0 0 0 48.9375 24.59375 A 1.0001 1.0001 0 0 0 48.90625 24.53125 A 1.0001 1.0001 0 0 0 48.875 24.5 A 1.0001 1.0001 0 0 0 48.71875 24.28125 L 48.6875 24.28125 A 1.0001 1.0001 0 0 0 48.625 24.21875 L 40.71875 16.28125 A 1.0001 1.0001 0 0 0 39.90625 15.96875 z"
        overflow="visible"
        font-family="Sans"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "logout",
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
